export default __webpack_public_path__ + "static/media/postgresql-logo.3cf9ba59.png";